import { useEffect, useRef } from 'react';

export const useScrollIntoViewOnChange = <T>(dep: T, options?: ScrollIntoViewOptions) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', ...options });
  }, [dep]);

  return { ref };
};
